<template>
  <v-card variant="outlined" elevation="1">
    <v-card-title>{{ title }}</v-card-title>
    <v-card-text>
      <slot />
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'VCardImportFormSection',

  props: {
    title: {
      type: String,
      required: true,
    },
  }
});
</script>
